(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-grates"] && !Shopify.designMode) return;
  try {
    (function () {
    function boot() {
      var root = document.getElementById('linsol-configurator');
      if (!root) return;
      var products = {
        'EZY-SER24-VL-MB': {
          style: 'Series 24 Vertical Pressed',
          finish: 'Matte Black',
          treatment: 'Powdercoat',
          price: 'From $305 / LM',
          image: 'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/EZY-SER24-VL-MB.png?v=1785831321',
          chip: '#171717',
        },
        'EZY-SER24-VL-BB': {
          style: 'Series 24 Vertical Pressed',
          finish: 'Brushed Brass',
          treatment: 'PVD',
          price: 'From $332 / LM',
          image: 'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/EZY-SER24-VL-BB.png?v=1785831291',
          chip: '#b68a3e',
        },
        'EZY-SER24-VL-GM': {
          style: 'Series 24 Vertical Pressed',
          finish: 'Gunmetal',
          treatment: 'PVD',
          price: 'From $332 / LM',
          image: 'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/EZY-SER24-VL-GM.png?v=1785831286',
          chip: '#4b4b4b',
        },
        'EZY-SER24-VL-BR': {
          style: 'Series 24 Vertical Pressed',
          finish: 'Brushed Nickel',
          treatment: 'Raw brush',
          price: 'From $278 / LM',
          image: 'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/EZY-SER24-VL-BR.png?v=1785831297',
          chip: '#9d9b96',
        },
        'EZY-SER24-TS-MB': {
          style: 'Series 24 Tile Insert',
          finish: 'Matte Black',
          treatment: 'Powdercoat',
          price: 'From $296 / LM',
          image: 'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/EZY-SER24-TS-MB.png?v=1785831308',
          chip: '#171717',
        },
        'EZY-SER24-TS-BB': {
          style: 'Series 24 Tile Insert',
          finish: 'Brushed Brass',
          treatment: 'PVD',
          price: 'From $314 / LM',
          image: 'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/EZY-SER24-TS-BB.png?v=1785831263',
          chip: '#b68a3e',
        },
        'EZY-SER24-TS-GM': {
          style: 'Series 24 Tile Insert',
          finish: 'Gunmetal',
          treatment: 'PVD',
          price: 'From $314 / LM',
          image: 'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/EZY-SER24-TS-GM.png?v=1785831316',
          chip: '#4b4b4b',
        },
        'EZY-SER24-TS-BR': {
          style: 'Series 24 Tile Insert',
          finish: 'Brushed Nickel',
          treatment: 'Raw brush',
          price: 'From $269 / LM',
          image: 'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/EZY-SER24-TS-BR.png?v=1785831302',
          chip: '#9d9b96',
        },
        'EZY-SER24-TS-AB': {
          style: 'Series 24 Tile Insert',
          finish: 'Aged Bronze',
          treatment: 'PVD',
          price: 'From $359 / LM',
          image: 'https://cdn.shopify.com/s/files/1/0424/4134/3137/files/EZY-SER24-TS-AB.png?v=1785831281',
          chip: '#7b5436',
        },
      };
      function chosen(name) {
        return root.querySelector('input[name="' + name + '"]:checked');
      }
      function value(name, fallback) {
        var el = chosen(name);
        return el ? el.value : fallback;
      }
      function text(id, v) {
        var el = document.getElementById(id);
        if (el) el.textContent = v;
      }
      function syncStyle(style) {
        var styleRadio = root.querySelector('input[name="grate_style"][value="' + style + '"]');
        if (styleRadio && !styleRadio.checked) styleRadio.checked = true;
      }
      function syncFinishGroups(style) {
        var tile = style.indexOf('Tile Insert') > -1,
          vertical = document.getElementById('vertical-finish-options'),
          insert = document.getElementById('tile-finish-options');
        if (vertical) {
          vertical.hidden = tile;
          vertical.setAttribute('aria-hidden', tile ? 'true' : 'false');
        }
        if (insert) {
          insert.hidden = !tile;
          insert.setAttribute('aria-hidden', tile ? 'false' : 'true');
        }
      }
      function updateSelectedCards() {
        root.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var label = input.closest('label');
          if (label) label.setAttribute('data-selected', input.checked ? 'true' : 'false');
        });
        ['exact_length_mm', 'outlet_position_mm'].forEach(function (name) {
          var input = root.querySelector('input[name="' + name + '"]'),
            label = input && input.closest('label');
          if (label) label.setAttribute('data-custom-selected', input.value ? 'true' : 'false');
        });
      }
      function update() {
        var sku = value('product_sku', 'EZY-SER24-VL-MB'),
          p = products[sku];
        if (!p) return;
        syncStyle(p.style);
        syncFinishGroups(p.style);
        var exact = root.querySelector('input[name="exact_length_mm"]');
        var length = exact && exact.value ? exact.value + ' mm' : value('length_choice', '1000mm').replace('mm', ' mm');
        var lengthNumber = parseInt(length, 10) || 1000;
        var layout = value('layout', 'Straight');
        var outletSize = value('outlet_size', '50mm').replace('mm', ' mm');
        var outletExact = root.querySelector('input[name="outlet_position_mm"]');
        var outletPos = outletExact && outletExact.value ? 'Custom' : value('outlet_position', 'Centre');
        var outletQty = value('outlet_quantity', '1 outlet');
        var outletCountLabel = outletQty.indexOf('3+') === 0 ? '3+' : String(parseInt(outletQty, 10) || 1);
        var supply = value('supply_format', 'Sections and joiners');
        var productImage = document.getElementById('preview-product-image');
        if (productImage.getAttribute('src') !== p.image) productImage.src = p.image;
        productImage.alt = p.style + ' in ' + p.finish + ' ' + p.treatment;
        var stage = document.getElementById('preview-product-stage');
        stage.classList.remove('is-changing');
        void stage.offsetWidth;
        stage.classList.add('is-changing');
        var proportionalLength = Math.max(0, Math.min(1, lengthNumber / 3000));
        var scale = 0.34 + 0.66 * proportionalLength;
        function sx(x) {
          return 180 + (x - 180) * scale;
        }
        function sy(y) {
          return 166 + (y - 166) * scale;
        }
        var pathByLayout = {
          Straight: 'M' + sx(70) + ' 188H' + sx(290),
          'Corner / L-shape': 'M' + sx(92) + ' ' + sy(95) + 'V' + sy(218) + 'H' + sx(292),
          'T-shape': 'M' + sx(58) + ' ' + sy(116) + 'H' + sx(302) + 'M180 ' + sy(116) + 'V' + sy(232),
          'Multiple runs':
            'M' +
            sx(70) +
            ' ' +
            sy(108) +
            'H' +
            sx(290) +
            'M' +
            sx(70) +
            ' ' +
            sy(198) +
            'H' +
            sx(290) +
            'M' +
            sx(110) +
            ' ' +
            sy(108) +
            'V' +
            sy(198) +
            'M' +
            sx(250) +
            ' ' +
            sy(108) +
            'V' +
            sy(198),
        };
        var runPath = pathByLayout[layout] || pathByLayout.Straight;
        ['waste-run', 'waste-run-shadow', 'waste-run-inset'].forEach(function (id) {
          document.getElementById(id).setAttribute('d', runPath);
        });
        var run = document.getElementById('waste-run'),
          inset = document.getElementById('waste-run-inset');
        run.setAttribute('stroke', p.chip);
        inset.setAttribute(
          'stroke',
          p.style.indexOf('Tile Insert') > -1 ? 'rgba(222,213,202,.96)' : 'url(#pressedSlots)'
        );
        inset.setAttribute('stroke-width', p.style.indexOf('Tile Insert') > -1 ? '10' : '10');
        document.getElementById('waste-run-group').removeAttribute('transform');
        var dimensionHalf = 110 * scale,
          dimensionStart = 180 - dimensionHalf,
          dimensionEnd = 180 + dimensionHalf;
        document
          .getElementById('waste-dimension-line')
          .setAttribute('d', 'M' + dimensionStart + ' 248H' + dimensionEnd);
        text('waste-dimension-text', length);
        var outletGroup = document.getElementById('waste-outlets'),
          joinGroup = document.getElementById('waste-joins');
        outletGroup.innerHTML = '';
        joinGroup.innerHTML = '';
        var qty = outletQty.indexOf('3+') === 0 ? 3 : parseInt(outletQty, 10) || 1,
          positions = [],
          layoutPoints = {
            Straight: {
              one: { Left: [95, 188], Centre: [180, 188], Right: [265, 188] },
              two: [
                [120, 188],
                [240, 188],
              ],
              three: [
                [95, 188],
                [180, 188],
                [265, 188],
              ],
            },
            'Corner / L-shape': {
              one: { Left: [92, 125], Centre: [190, 218], Right: [270, 218] },
              two: [
                [92, 145],
                [235, 218],
              ],
              three: [
                [92, 120],
                [150, 218],
                [270, 218],
              ],
            },
            'T-shape': {
              one: { Left: [90, 116], Centre: [180, 116], Right: [270, 116] },
              two: [
                [105, 116],
                [255, 116],
              ],
              three: [
                [80, 116],
                [180, 116],
                [280, 116],
              ],
            },
            'Multiple runs': {
              one: { Left: [110, 153], Centre: [180, 108], Right: [250, 153] },
              two: [
                [110, 108],
                [250, 198],
              ],
              three: [
                [110, 108],
                [250, 108],
                [180, 198],
              ],
            },
          },
          pointSet = layoutPoints[layout] || layoutPoints.Straight;
        positions =
          qty === 1 ? [pointSet.one[outletPos] || pointSet.one.Centre] : qty === 2 ? pointSet.two : pointSet.three;
        if (qty === 1 && outletExact && outletExact.value && layout === 'Straight' && lengthNumber > 0) {
          var outletRatio = Math.max(0, Math.min(1, parseInt(outletExact.value, 10) / lengthNumber));
          positions = [[70 + 220 * outletRatio, 188]];
        }
        positions = positions.map(function (pt) {
          return layout === 'Straight' ? [sx(pt[0]), pt[1]] : [sx(pt[0]), sy(pt[1])];
        });
        var outletRadius = outletSize.indexOf('80') === 0 ? 12 : outletSize.indexOf('70') === 0 ? 10 : 8;
        positions.forEach(function (pt) {
          outletGroup.innerHTML +=
            '<circle cx="' +
            pt[0] +
            '" cy="' +
            pt[1] +
            '" r="' +
            outletRadius +
            '" fill="#f3eee8" stroke="' +
            p.chip +
            '" stroke-width="4"/><circle cx="' +
            pt[0] +
            '" cy="' +
            pt[1] +
            '" r="3" fill="' +
            p.chip +
            '"/>';
        });
        outletGroup.setAttribute('display', 'block');
        if (supply === 'Sections and joiners' && lengthNumber > 1500 && layout === 'Straight') {
          [143, 217].forEach(function (x) {
            joinGroup.innerHTML +=
              '<path d="M' + sx(x) + ' 175v26" stroke="#fff" stroke-width="3" stroke-dasharray="3 3"/>';
          });
        }
        var chip = document.getElementById('preview-finish-chip');
        chip.textContent = p.finish + ' · ' + p.treatment;
        chip.style.background = p.chip;
        text('preview-product-name', p.style);
        text('preview-sku', sku);
        text('preview-price', p.price);
        text('preview-length', length);
        text('preview-layout', layout);
        text(
          'preview-outlet',
          outletCountLabel +
            ' × ' +
            outletSize +
            ' · ' +
            (outletExact && outletExact.value ? outletExact.value + ' mm from left' : outletPos)
        );
        text('preview-supply', supply);
        text('preview-stage-length', length + ' finished length');
        text('preview-stage-outlet', outletCountLabel + ' × ' + outletSize + ' · ' + outletPos);
        var warning = [];
        if (exact && exact.value && (lengthNumber < 1 || lengthNumber > 3000))
          warning.push('Finished length must be within the verified 3000 mm maximum.');
        if (outletExact && outletExact.value && parseInt(outletExact.value, 10) >= lengthNumber)
          warning.push('Outlet centre must be less than the finished length.');
        if (layout !== 'Straight' || outletQty !== '1 outlet')
          warning.push('This configuration needs a specialist quote and drawing review.');
        if (supply === 'One piece' && lengthNumber > 1500)
          warning.push('One-piece supply above 1500 mm needs a freight review.');
        var warningBox = document.getElementById('preview-measure-warning');
        warningBox.textContent = warning.join(' ');
        warningBox.style.display = warning.length ? 'block' : 'none';
        updateSelectedCards();
        var bodyField = root.querySelector('[data-grate-body]');
        if (bodyField) {
          var nameInput = root.querySelector('[name="contact[name]"]');
          var emailInput = root.querySelector('[name="contact[email]"]');
          var phoneInput = root.querySelector('[name="contact[phone]"]');
          var postcodeInput = root.querySelector('[name="contact[Postcode]"]');
          var notesInput = root.querySelector('[name="contact[Project notes]"]');
          bodyField.value = [
            'Custom grate quote',
            '',
            'Name: ' + (nameInput ? nameInput.value.trim() : ''),
            'Email: ' + (emailInput ? emailInput.value.trim() : ''),
            'Phone: ' + (phoneInput ? phoneInput.value.trim() : ''),
            'Postcode: ' + (postcodeInput ? postcodeInput.value.trim() : ''),
            '',
            'Style: ' + p.style,
            'Finish: ' + p.finish + ' · ' + p.treatment,
            'SKU: ' + sku,
            'Price: ' + p.price,
            'Length: ' + length,
            'Layout: ' + layout,
            'Outlet: ' +
              outletCountLabel +
              ' × ' +
              outletSize +
              ' · ' +
              (outletExact && outletExact.value ? outletExact.value + ' mm from left' : outletPos),
            'Supply: ' + supply,
            '',
            'Project notes:',
            notesInput && notesInput.value.trim() ? notesInput.value.trim() : '—',
          ].join('\n');
        }
      }
      function shouldUpdatePreview(event) {
        var target = event.target;
        if (!target || !target.closest) return true;
        if (target.closest('.ap-grate__contact') || target.hasAttribute('data-grate-contact')) return false;
        return true;
      }
      root.addEventListener('change', function (e) {
        if (!shouldUpdatePreview(e)) return;
        if (e.target.name === 'grate_style') {
          var wanted = e.target.value.indexOf('Tile Insert') > -1 ? 'EZY-SER24-TS-MB' : 'EZY-SER24-VL-MB';
          var productRadio = root.querySelector('input[name="product_sku"][value="' + wanted + '"]');
          if (productRadio) productRadio.checked = true;
        }
        if (e.target.name === 'length_choice') {
          var exact = root.querySelector('input[name="exact_length_mm"]');
          if (exact) exact.value = '';
        }
        if (e.target.name === 'outlet_position') {
          var outletExact = root.querySelector('input[name="outlet_position_mm"]');
          if (outletExact) outletExact.value = '';
        }
        update();
      });
      root.addEventListener('input', function (e) {
        if (!shouldUpdatePreview(e)) return;
        if (e.target.name === 'exact_length_mm') {
          var lengthRadios = root.querySelectorAll('input[name="length_choice"]');
          if (e.target.value) {
            lengthRadios.forEach(function (radio) {
              radio.checked = false;
            });
          } else if (!chosen('length_choice') && lengthRadios[0]) {
            lengthRadios[0].checked = true;
          }
        }
        if (e.target.name === 'outlet_position_mm') {
          var outletRadios = root.querySelectorAll('input[name="outlet_position"]');
          if (e.target.value) {
            outletRadios.forEach(function (radio) {
              radio.checked = false;
            });
          } else if (!chosen('outlet_position') && outletRadios[1]) {
            outletRadios[1].checked = true;
          }
        }
        update();
      });
      function prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      function stickyOffset() {
        var styles = getComputedStyle(document.documentElement);
        var header = parseFloat(styles.getPropertyValue('--header-height')) || 0;
        var announcement = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
        var isSticky = parseFloat(styles.getPropertyValue('--header-is-sticky')) || 0;
        return (header + announcement) * isSticky + 24;
      }

      function scrollPastHeader(element) {
        if (!element) return;
        var target = element.closest('label') || element;
        var top = target.getBoundingClientRect().top + window.scrollY - stickyOffset();
        window.scrollTo({
          top: Math.max(0, top),
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        });
        if (typeof element.focus === 'function') {
          element.focus({ preventScroll: true });
        }
      }

      function scrollToAlert(element) {
        scrollPastHeader(element);
      }

      var invalidScrollScheduled = false;
      root.addEventListener(
        'invalid',
        function (event) {
          if (invalidScrollScheduled) return;
          invalidScrollScheduled = true;
          var field = event.target;
          window.setTimeout(function () {
            scrollPastHeader(field);
            invalidScrollScheduled = false;
          }, 50);
        },
        true
      );

      function ensureReturnTo() {
        var contactSection = root.querySelector('.ap-grate__contact');
        var anchor = contactSection && contactSection.id ? '#' + contactSection.id : '';
        var returnUrl = window.location.pathname + '?contact_posted=true' + anchor;
        var returnInput = root.querySelector('input[name="return_to"]');
        if (!returnInput) {
          returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          root.insertBefore(returnInput, root.firstChild);
        }
        returnInput.value = returnUrl;
      }

      function revealSuccess() {
        if (!success) return;
        success.hidden = false;
        success.removeAttribute('hidden');
        root.reset();
        update();
        scrollToAlert(success);
      }

      var success = root.querySelector('[data-grate-success]');

      root.addEventListener('submit', function () {
        update();
        ensureReturnTo();
        var button = root.querySelector('[data-grate-submit]');
        if (button) {
          button.disabled = true;
          button.textContent = button.getAttribute('data-sending-label') || 'Sending…';
        }
      });

      ensureReturnTo();
      update();

      var postedFromUrl = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
      if (success && !success.hidden) {
        root.reset();
        update();
        scrollToAlert(success);
      } else if (postedFromUrl) {
        revealSuccess();
      } else {
        var errorAlert = root.querySelector('.ap-grate__alert--error');
        if (errorAlert) scrollToAlert(errorAlert);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-newsletter-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-newsletter-form')) {
    class CustomNewsletterForm extends HTMLElement {
      #callingCodes = {
        AU: '61',
        NZ: '64',
        US: '1',
        CA: '1',
        GB: '44'
      };

      connectedCallback() {
        this.form = this.querySelector('form');
        this.phoneInput = this.querySelector('[data-newsletter-phone]');
        this.consentInput = this.querySelector('[data-sms-consent]');
        this.consentRow = this.querySelector('[data-sms-consent-row]');
        this.#syncFilledFields();
        this.#syncSmsConsentRequirement();
        this.#scrollSectionIntoView();
        this.form?.addEventListener('submit', this.#onSubmit);
        this.phoneInput?.addEventListener('input', this.#onPhoneInput);
        this.phoneInput?.addEventListener('change', this.#onPhoneInput);
        this.consentInput?.addEventListener('change', this.#onConsentChange);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.#onSubmit);
        this.phoneInput?.removeEventListener('input', this.#onPhoneInput);
        this.phoneInput?.removeEventListener('change', this.#onPhoneInput);
        this.consentInput?.removeEventListener('change', this.#onConsentChange);
      }

      #onPhoneInput = () => {
        this.phoneInput?.setCustomValidity('');
        this.#syncFilledFields();
        this.#syncSmsConsentRequirement();
      };

      #onConsentChange = () => {
        this.consentInput?.setCustomValidity('');
      };

      #hasPhoneValue() {
        return Boolean(this.phoneInput?.value.trim());
      }

      #syncSmsConsentRequirement() {
        if (!this.consentInput) return;

        const hasPhone = this.#hasPhoneValue();
        this.consentInput.required = hasPhone;
        this.consentInput.disabled = !hasPhone;
        if (this.consentRow) {
          this.consentRow.hidden = !hasPhone;
        }

        if (hasPhone) {
          this.consentInput.setAttribute('aria-required', 'true');
        } else {
          this.consentInput.removeAttribute('aria-required');
          this.consentInput.setCustomValidity('');
        }
      }

      #syncFilledFields() {
        const fields = this.querySelectorAll('.form__field');
        for (const field of fields) {
          field.classList.toggle('is-filled', field.value !== '');
        }
      }

      #scrollSectionIntoView() {
        const form = this.querySelector('form');
        if (!form) return;

        const hashMatches = window.location.hash === `#${form.id}`;
        const hasAlert = Boolean(this.querySelector('.alert'));
        if (!hashMatches && !hasAlert) return;

        const section = this.closest('.custom_newsletter') || this.closest('.back_cust-news') || this;
        section.scrollIntoView({ block: 'start', behavior: 'auto' });
      }

      #toE164(value) {
        const raw = (value || '').trim();
        if (!raw) return '';

        const hasPlus = raw.startsWith('+');
        let digits = raw.replace(/\D/g, '');
        if (!digits) return '';

        const iso = (this.dataset.country || 'AU').toUpperCase();
        const callingCode = this.#callingCodes[iso] || '61';

        if (hasPlus) {
          if (digits.length < 8) return '';
          return `+${digits}`;
        }

        if (digits.startsWith(callingCode) && digits.length >= callingCode.length + 8) {
          return `+${digits}`;
        }

        if (digits.startsWith('0')) {
          digits = digits.slice(1);
        }

        if (digits.length < 8) return '';
        return `+${callingCode}${digits}`;
      }

      #onSubmit = (event) => {
        const phoneInput = this.phoneInput || this.querySelector('[data-newsletter-phone]');
        const consentInput = this.consentInput || this.querySelector('[data-sms-consent]');
        if (!phoneInput) return;

        const rawPhone = phoneInput.value.trim();
        if (!rawPhone) {
          phoneInput.setCustomValidity('');
          if (consentInput) {
            consentInput.required = false;
            consentInput.removeAttribute('aria-required');
            consentInput.setCustomValidity('');
            consentInput.removeAttribute('name');
          }
          return;
        }

        const e164 = this.#toE164(phoneInput.value);
        if (!e164) {
          event.preventDefault();
          phoneInput.setCustomValidity(this.dataset.phoneError || 'Enter a valid phone number');
          phoneInput.reportValidity();
          return;
        }

        phoneInput.setCustomValidity('');

        if (!consentInput) return;

        this.#syncSmsConsentRequirement();
        if (!consentInput.checked) {
          event.preventDefault();
          consentInput.setCustomValidity(
            this.dataset.consentError || 'Please agree to receive marketing texts'
          );
          consentInput.reportValidity();
          return;
        }

        consentInput.setCustomValidity('');
        const smsTag = this.dataset.smsTag || 'sms-opt-in';
        const phoneDigits = e164.replace('+', '');
        consentInput.value = ['newsletter', `${smsTag}-${phoneDigits}`].join(',');
      };
    }

    customElements.define('custom-newsletter-form', CustomNewsletterForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__apqPdpQuoteBound) return;
    window.__apqPdpQuoteBound = true;

    let isAdding = false;

    const waitForRQ = () => {
      if (window.RQ && typeof window.RQ.addItemFromForm === 'function') {
        return Promise.resolve(window.RQ);
      }
      return new Promise((resolve, reject) => {
        const timeout = window.setTimeout(() => {
          document.removeEventListener('rq:ready', onReady);
          reject(new Error('Quote store unavailable'));
        }, 4000);
        const onReady = () => {
          window.clearTimeout(timeout);
          resolve(window.RQ);
        };
        document.addEventListener('rq:ready', onReady, { once: true });
      });
    };

    const quoteButtons = () => document.querySelectorAll('[data-action="add-to-quote"]');

    const setQuoteLabel = (button, text) => {
      const label = button.querySelector('[data-quote-label]');
      if (label) {
        label.textContent = text;
        return;
      }
      button.textContent = text;
    };

    const findProductForm = (button) => {
      const bcpo = document.getElementById('bcpo');
      const bcpoForm = bcpo && bcpo.closest('form[action*="/cart/add"]');
      const nested = button.closest('form[action*="/cart/add"]');

      if (nested && (!bcpoForm || nested === bcpoForm || nested.contains(bcpo))) return nested;
      if (bcpoForm) return bcpoForm;

      const buyButtonsBlock = document.querySelector('.product-info__block-item--buy-buttons');
      const blockForm = buyButtonsBlock && buyButtonsBlock.closest('form[action*="/cart/add"]');
      if (blockForm) return blockForm;

      return document.querySelector('form.product-form[action*="/cart/add"]');
    };

    const markQuoteAdded = (sourceButton) => {
      const addedLabel = sourceButton.getAttribute('data-label-added') || 'Added to quote';
      for (const button of quoteButtons()) {
        button.dataset.inQuote = 'true';
        setQuoteLabel(button, addedLabel);
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };

    const setQuoteBusy = (busy, sourceButton) => {
      const addingLabel = sourceButton.getAttribute('data-label-adding') || 'Adding…';
      const addLabel = sourceButton.getAttribute('data-label-add') || 'Add to quote';
      for (const button of quoteButtons()) {
        if (button.dataset.inQuote === 'true') continue;
        button.disabled = busy;
        button.setAttribute('aria-busy', busy ? 'true' : 'false');
        setQuoteLabel(button, busy ? addingLabel : addLabel);
      }
    };

    const scrollToOptions = () => {
      const bcpoElement = document.getElementById('bcpo');
      if (!bcpoElement) return;
      const styles = getComputedStyle(document.documentElement);
      const announcementHeight = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
      const headerHeight = parseFloat(styles.getPropertyValue('--header-height')) || 0;
      const top = bcpoElement.getBoundingClientRect().top + window.scrollY - announcementHeight - headerHeight - 16;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    };

    const showFormError = (button, message) => {
      const row = button.closest('.product-form__cta-row') || button.closest('.product-form__quote-row') || button.parentElement;
      if (!row) return;

      const existing = row.parentElement && row.parentElement.querySelector('.product-form__quote-error');
      if (existing) existing.remove();

      const error = document.createElement('p');
      error.className = 'product-form__quote-error alert alert--error';
      error.setAttribute('role', 'alert');
      error.textContent = message;
      row.insertAdjacentElement('afterend', error);
      window.setTimeout(() => error.remove(), 5500);
    };

    const handleBuyNowClick = (event) => {
      const button = event.target.closest('[data-action="buy-now"]');
      if (!button || button.disabled) return;

      event.preventDefault();

      const form = findProductForm(button);
      if (!form) return;
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
        scrollToOptions();
        return;
      }

      const row = button.closest('.product-form__cta-row');
      const atcButton =
        (row && row.querySelector('[data-action="add-to-cart"]')) ||
        form.querySelector('[data-action="add-to-cart"]');

      if (!atcButton || atcButton.disabled) {
        showFormError(button, button.getAttribute('data-label-error') || '');
        return;
      }

      const cartUrl = button.getAttribute('data-cart-url') || (window.routes && window.routes.cartUrl) || '/cart';
      const separator = cartUrl.includes('?') ? '&' : '?';
      const cartHandoffUrl = `${cartUrl}${separator}buy_now=1`;

      try {
        sessionStorage.setItem('pdpBuyNowCheckout', String(Date.now()));
        sessionStorage.removeItem('pdpBuyNowCheckoutDone');
      } catch (storageError) {
        // Ignore private-mode storage failures; the query param still works.
      }

      let returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
      }
      returnInput.value = cartHandoffUrl;

      const goToCart = () => {
        window.location.assign(cartHandoffUrl);
      };

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      document.addEventListener('product:added', goToCart, { once: true });
      window.setTimeout(() => {
        document.removeEventListener('product:added', goToCart);
        if (button.getAttribute('aria-busy') === 'true') {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }, 8000);

      atcButton.click();
    };

    const handleQuoteClick = async (event) => {
      const button = event.target.closest('[data-action="add-to-quote"]');
      if (!button || button.disabled) return;

      event.preventDefault();

      const quoteUrl = button.getAttribute('data-quote-url') || '/pages/request-a-quote';
      if (button.dataset.inQuote === 'true') {
        window.location.assign(quoteUrl);
        return;
      }

      if (isAdding) return;

      const form = findProductForm(button);
      if (!form) return;
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
        scrollToOptions();
        return;
      }

      isAdding = true;
      setQuoteBusy(true, button);

      try {
        const quote = await waitForRQ();
        await quote.addItemFromForm(form, {
          product_id: button.getAttribute('data-product-id'),
          handle: button.getAttribute('data-product-handle'),
          product_title: button.getAttribute('data-product-title'),
          url: button.getAttribute('data-product-url'),
          image: button.getAttribute('data-product-image'),
          source: 'pdp'
        });
        quote.markStarted('add');
        markQuoteAdded(button);
        if (typeof quote.show === 'function') quote.show();
      } catch (error) {
        showFormError(button, button.getAttribute('data-label-error') || '');
        setQuoteBusy(false, button);
      } finally {
        isAdding = false;
      }
    };

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-action="add-to-quote"]')) {
        handleQuoteClick(event);
        return;
      }
      if (event.target.closest('[data-action="buy-now"]')) {
        handleBuyNowClick(event);
      }
    });

    const hydrateQuoteButtons = () => {
      if (window.RQ && typeof window.RQ.syncTriggers === 'function') window.RQ.syncTriggers();
    };
    hydrateQuoteButtons();
    document.addEventListener('rq:ready', hydrateQuoteButtons);
    document.addEventListener('rq:change', hydrateQuoteButtons);
  })();
  } catch(e) { console.error(e); }
})();

})();
